import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {SceneService} from "@/services/scene-service";
import {SceneName} from "@/model/scene-name";
import SceneUtils from "@/utils/scene-utils";
import {CapacitorService} from "@/services/capacitor-service";
import SpriteUtils from "@/utils/sprite-utils";
import PlayerStore from "@/store/player";
import CU from "@/utils/c-u";
import {IntegrationUtils} from "@/utils/integration-utils";

export default class PreloadScene extends Scene {

    @lazyInject(TYPES.SceneService)
    private sceneService!: SceneService;

    @lazyInject(TYPES.CapacitorService)
    private capacitorService!: CapacitorService;

    constructor() {
        super({
            key: 'PreloadScene',
            pack: {
                files: [
                    { type: 'image', key: Keys.IMG_LOAD_SCREEN_BACKGROUND, url: 'assets/bg/load_screen_background.jpg' },
                ]
            }
        });
    }

    public preload(): void {
        PlayerStore.logLoadPreboot();
        let canvas = this.sys.game.canvas;
        SpriteUtils.addSprite(this, canvas.width / 2 / CU.S,canvas.height / 2 / CU.S,  Keys.IMG_LOAD_SCREEN_BACKGROUND);

        document.getElementById('bg')!.style.display = "none";
        const canvasParrent = <HTMLElement> document.getElementById('game-container');
        canvasParrent.style.height = '100%';
        if (!!canvasParrent && (IntegrationUtils.isVkUser() || IntegrationUtils.isExeUser())) {
            canvasParrent.scrollIntoView();
        }


        SceneUtils.setCurrentScene(this);
        this.load.atlas(Keys.ATLAS_PRELOAD, 'assets/ui/preload.png', 'assets/ui/preload.json');
        // this.load.image(Keys.IMG_LOAD_SCREEN_BACKGROUND,'assets/bg/load_screen_background.jpg');
        this.load.image(Keys.AGE_12,'assets/age12.png');

        this.load.on('complete', () => {
            this.sceneService.startSceneInstant(this, SceneName.BOOT_SCENE);
        })
        if (process.env.VUE_APP_IS_MOBILE_APP === 'true') {
            this.capacitorService.init()
            this.capacitorService.fullScreen()
        }
    }
}
